// extracted by mini-css-extract-plugin
module.exports = {"categoryDetails":"RecipeListItem_categoryDetails__2wtCP","categoryImage":"RecipeListItem_categoryImage__iDJay","categoryItem":"RecipeListItem_categoryItem__3Z8Ds"};